import { Col, Divider, Row, Typography } from 'antd';
import { InlineStylesModel } from 'models/InlineStylesModel';
import { SparingRequest } from 'models/SparingRequests';
import moment from 'moment';
import momentTz from 'moment-timezone';
import { FC } from 'react';
import { InfoField } from './InfoField';

const styles: InlineStylesModel = {
  headerTitle: {
    fontWeight: 'bold',
    color: '#2F5596',
    whiteSpace: 'nowrap'
  }
};

type Props = {
  values: SparingRequest;
};

export const DeploymentRequestInfoPosted: FC<Props> = ({ values }) => {
  const outageAddress = `${values.outageLocation.name}: ${values.outageLocation.code}: ${values.outageLocation.street1}, ${values.outageLocation.city}, ${
    values.outageLocation?.subdivisionLocalCode || ''
  }, ${values.outageLocation.country || ''} ${values.outageLocation.postalCode}`;

  const shippingAddress = values.shippingLocation
    ? `${values.shippingLocation.name}: ${values.shippingLocation.code}: ${values.shippingLocation.street1}, ${values.shippingLocation.city}, ${values.shippingLocation?.subdivisionLocalCode || ''}, ${
        values.shippingLocation.country || ''
      } ${values.shippingLocation.postalCode}`
    : '';

  const time = momentTz.utc(values.createdDateTime).tz('America/New_York').format('MM/DD/YYYY hh:mm A');

  return (
    <div style={{ marginBottom: 20 }}>
      <Row align="middle" gutter={[15, 15]} style={{ marginBottom: 10 }}>
        <Col>
          <InfoField>
            <Typography.Text style={styles.headerTitle}>Sparing Request Number: </Typography.Text>
            <Typography.Text>{values.requestNumber}</Typography.Text>
          </InfoField>
        </Col>
        {values.customerReferenceNumber && (
          <Col>
            <InfoField>
              <Typography.Text style={styles.headerTitle}>{values.sparingRequestType.reference1Label || 'Primary Reference Number'}: </Typography.Text>
              <Typography.Text>{values.customerReferenceNumber}</Typography.Text>
            </InfoField>
          </Col>
        )}
        {values.customerPurchaseOrderNumber && (
          <Col>
            <InfoField>
              <Typography.Text style={styles.headerTitle}>{values.sparingRequestType.reference2Label || 'Secondary Reference Number'}: </Typography.Text>
              <Typography.Text>{values.customerPurchaseOrderNumber}</Typography.Text>
            </InfoField>
          </Col>
        )}
        {values.endCustomer && values.sparingRequestType.isEndCustomerVisible && (
          <Col>
            <InfoField>
              <Typography.Text style={styles.headerTitle}>End Customer: </Typography.Text>
              <Typography.Text>{values.endCustomer}</Typography.Text>
            </InfoField>
          </Col>
        )}
        {values.sparingRequestType.name && (
          <Col>
            <InfoField>
              <Typography.Text style={styles.headerTitle}>Spare Type: </Typography.Text>
              <Typography.Text>{values.sparingRequestType.name}</Typography.Text>
            </InfoField>
          </Col>
        )}
        {values.status && (
          <Col>
            <InfoField>
              <Typography.Text style={styles.headerTitle}>Status: </Typography.Text>
              <Typography.Text>{values.status === 'Posted' ? 'Open' : values.status}</Typography.Text>
            </InfoField>
          </Col>
        )}
        {values.createdDateTime && (
          <Col>
            <InfoField>
              <Typography.Text style={styles.headerTitle}>Created Date: </Typography.Text>
              <Typography.Text>{moment.utc(values.createdDateTime).format('MM/DD/YYYY HH:mm A')} UTC</Typography.Text>
              <Divider type="vertical" style={{ borderColor: '#d9d9d9', marginRight: 0, marginLeft: 0, paddingRight: 0, paddingLeft: 0 }} />
              <Typography.Text>{time} EST</Typography.Text>
            </InfoField>
          </Col>
        )}
        {values.createdByFullName && (
          <Col>
            <InfoField>
              <Typography.Text style={styles.headerTitle}>Requester: </Typography.Text>
              <Typography.Text>{values.createdByFullName}</Typography.Text>
            </InfoField>
          </Col>
        )}
      </Row>
      <Row align="middle" gutter={[0, 8]} style={{ marginBottom: 8 }}>
        {outageAddress && (
          <Col span={24} xxl={24}>
            <InfoField noWrap>
              <Typography.Text style={styles.headerTitle}>Outage Address: </Typography.Text>
              <Typography.Text ellipsis={{ tooltip: true }} style={{ textTransform: 'capitalize' }}>
                {outageAddress}
              </Typography.Text>
            </InfoField>
          </Col>
        )}
        {shippingAddress && (
          <Col span={24} xxl={24}>
            <InfoField noWrap>
              <Typography.Text style={styles.headerTitle}>Shipping Address: </Typography.Text>
              <Typography.Text ellipsis={{ tooltip: true }} style={{ textTransform: 'capitalize' }}>
                {shippingAddress}
              </Typography.Text>
            </InfoField>
          </Col>
        )}
      </Row>
    </div>
  );
};
